// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useRef, useState } from 'react';
import S from './style';
import { FormattedMessage } from 'react-intl';

export interface DragPreviewProps {
}

const Drag = (props: DragPreviewProps): JSX.Element => {
  return (
    <S.Container>
      <S.Title>
        <FormattedMessage id={'I031'}/>
      </S.Title>
    </S.Container>
  )
}

export { Drag as default };
